import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Observable } from 'rxjs';
import { shareReplay } from 'rxjs/operators';

import { ListSuspiciousTechnicalInspection } from '@app/technical-inspections/_models/list-suspicious-technical-inspection.model';
import { SortingPagingData } from '@helpers/sorting-paging-data';
import { Page } from '@interfaces/page';
import { environment } from 'src/environments/environment';

const baseUrl                = environment.apiBaseURL + '/suspicious-technical-inspection';
const pageableUrl            = baseUrl + '/pageable';
const pageableTotalCountUrl  = baseUrl + '/pageable/count';

@Injectable({ providedIn: 'root' })
export class SuspiciousTechnicalInspectionService {

    constructor(private http: HttpClient) {}

    public getPagableSuspiciousTechnicalInspections(sortingPaging: SortingPagingData, searchObject: FormGroup, fromDate: string, toDate: string): Observable<Page<ListSuspiciousTechnicalInspection>> {
        const requestParams = this.createSearchHttpRequestParams(sortingPaging, searchObject, fromDate, toDate);
        return this.http.get<any>(pageableUrl, { params: requestParams }).pipe(shareReplay());
    }

    public getTotalElements(sortingPaging: SortingPagingData, searchObject: FormGroup, fromDate: string, toDate: string): Observable<number> {
        const requestParams = this.createSearchHttpRequestParams(sortingPaging, searchObject, fromDate, toDate);
        return this.http.get<any>(pageableTotalCountUrl, { params: requestParams }).pipe(shareReplay());
    }

    private createSearchHttpRequestParams(sortingPaging: SortingPagingData, searchObject: FormGroup, fromDate: string, toDate: string) {
        let requestParams = new HttpParams();

        if (sortingPaging != null) {
            requestParams = requestParams.set("page", sortingPaging.getPageNumber());
            requestParams = requestParams.set("pageSize", sortingPaging.getPageSize());
        }

        if (sortingPaging.isSortingValid()) {
            requestParams = requestParams
                .set("sortBy", sortingPaging.sortBy)
                .set("sortAsc", sortingPaging.sortAsc === null ? 'null' : (sortingPaging.sortAsc ? 'true' : 'false'));
        }

        Object.entries(searchObject).forEach(item => {
            if (item[1] && item[1].length !== 0) {
                requestParams = requestParams.set(item[0], item[1]);
            }
        });

        if (fromDate && fromDate.length !== 0) {
            requestParams = requestParams.set("fromDate", fromDate);
        }
        if (toDate && toDate.length !== 0) {
            requestParams = requestParams.set("toDate", toDate);
        }

        return requestParams;
    }
}
